import { useEffect, useState } from "react";
import uploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import UtilsUrl from "../../../utils/UtilsUrl";
import UtilsFormule from "../../../utils/UtilsFormule";
import UtilsFormuleSell from "../../../utils/UtilsFormuleSell";

const EspecePayementDetailV2 = (payementAvance) => {
  const [payement, setPayement] = useState("");
  useEffect(() => {
    console.log(payementAvance?.payementAvance)
  }, [])
  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        // Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          // Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          // Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          // Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          // Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch(() => {
        // setOpenErrorAlert(true);
        // setErrorAlertText("Erreur : il y a un problème de connexion");
      });
  };

  return (
    <div className="row">
      <div className="user-block">
        Payement en <b>Espèce</b> le :{" "}
        {UtilsFormule.formatDate(payementAvance?.payementAvance.creationDate)}
        {!payementAvance?.hideReceipt &&
          payementAvance?.payementAvance.urlFile !== "any" && (
          <button
            className="link-black text-sm float-right"
            style={{ backgroundColor: "white", border: "none" }}
            onClick={() =>
              onShowFileInOtherWizndowHandler(
                UtilsUrl.fileRetailURL() + payementAvance?.payementAvance.urlFile
              )
            }
          >
            <i className="fas fa-link mr-1" /> Télécharger reçu
          </button>
        )}
        <br />
        Montant payée: {payementAvance?.payementAvance.amountPayed} TND
        <br />
        {UtilsFormuleSell.TypePayementValidation(payementAvance)}
        <br />
      </div>
    </div>
  );
};

export default EspecePayementDetailV2;